// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import DragDropUploadController from './drag_drop_upload_controller';
import ProductSearchController from './product_search_controller';
import SortableController from './sortable_controller';
import TimezoneController from './timezone_controller';
import ThemeController from './theme_controller';
import UiPageNavbarController from '../../components/ui/page/navbar_component/navbar_controller';

application.register('drag-drop-upload', DragDropUploadController);
application.register('product-search', ProductSearchController);
application.register('sortable', SortableController);
application.register('timezone', TimezoneController);
application.register('theme', ThemeController);
application.register('ui--page--navbar', UiPageNavbarController);
